"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const LocaleContext = /*#__PURE__*/(0, _react.createContext)(undefined);
var _default = exports.default = LocaleContext;